import usePartyStore from "../../stores/party.js";
import Party from "../../modules/party/index.js";
import Player from "../../modules/player/index.js";
import { Results } from "@tumbodash/browserPackages";
import { Link } from "react-router-dom";
import { ReactComponents } from "@tumbodash/browserPackages";

const MEDALS = ["🥇", "🥈", "🥉"];

function PartyResults() {
	const party = usePartyStore.getState().party!;
	const results = Party.aggregateResults();
	const activePlayerId = Player.getActiveId();

	const winner = results[0];
	const winnerPlayer = winner ? party.players[winner.playerId as string] : null;

	return (
		<div style={{
			minHeight: "100dvh",
			display: "flex",
			flexDirection: "column",
			background: "var(--bg-base)",
		}}>
			{/* Navbar */}
			<nav style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				padding: "var(--space-3) var(--space-4)",
				borderBottom: "1px solid var(--border)",
			}}>
				<ReactComponents.Logo />
			</nav>

			<div style={{
				flex: 1,
				display: "flex",
				flexDirection: "column",
				gap: "var(--space-5)",
				padding: "var(--space-5) var(--space-4)",
				maxWidth: 480,
				width: "100%",
				margin: "0 auto",
			}}>

				{/* ── Winner hero ── */}
				{winnerPlayer && (
					<div style={{
						background: "var(--bg-surface)",
						border: "1px solid rgba(255,230,109,0.2)",
						borderRadius: "var(--radius-lg)",
						padding: "var(--space-6) var(--space-5)",
						textAlign: "center",
					}}>
						<div style={{ fontSize: "2.5rem", marginBottom: "var(--space-3)" }}>🏆</div>
						<div style={{
							fontSize: "1.5rem",
							fontWeight: 900,
							letterSpacing: "-0.02em",
							color: winnerPlayer.color,
						}}>
							{winnerPlayer.name}
						</div>
						<div style={{
							fontSize: "0.82rem",
							color: "var(--reward)",
							fontWeight: 700,
							letterSpacing: "0.06em",
							textTransform: "uppercase",
							marginTop: "var(--space-2)",
						}}>
							Party Winner · {winner.score as number} pts
						</div>
					</div>
				)}

				{/* ── Final leaderboard ── */}
				<div>
					<div style={{
						fontSize: "0.72rem",
						fontWeight: 700,
						letterSpacing: "0.08em",
						textTransform: "uppercase",
						color: "var(--text-muted)",
						marginBottom: "var(--space-3)",
					}}>
						Final Standings
					</div>
					<div style={{ display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
						{results.map((row: Record<string, unknown>, i: number) => {
							const player = party.players[row.playerId as string];
							const position = row.position as number;
							const isMe = row.playerId === activePlayerId;
							const isWinner = position === 1;
							if (!player) return null;

							return (
								<div
									key={i}
									style={{
										display: "flex",
										alignItems: "center",
										gap: "var(--space-3)",
										padding: "var(--space-3) var(--space-4)",
										borderRadius: "var(--radius-md)",
										background: isMe ? "var(--bg-elevated)" : "var(--bg-surface)",
										border: `1px solid ${isWinner ? "rgba(255,230,109,0.2)" : isMe ? "var(--border-strong)" : "var(--border)"}`,
									}}
								>
									<span style={{
										width: 24,
										textAlign: "center",
										fontSize: position <= 3 ? "1.1rem" : "0.95rem",
										fontWeight: 800,
										color: isWinner ? "var(--reward)" : "var(--text-muted)",
										flexShrink: 0,
									}}>
										{position <= 3 ? MEDALS[position - 1] : position}
									</span>
									<div style={{
										width: 10,
										height: 10,
										borderRadius: "50%",
										background: player.color,
										flexShrink: 0,
										boxShadow: `0 0 6px ${player.color}88`,
									}} />
									<span style={{
										flex: 1,
										fontWeight: 600,
										fontSize: "0.95rem",
										color: player.color,
									}}>
										{player.name}
									</span>
									{isMe && (
										<span style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>you</span>
									)}
									<span style={{
										fontWeight: 700,
										color: "var(--reward)",
										background: "var(--reward-muted)",
										border: "1px solid rgba(255,230,109,0.2)",
										borderRadius: "var(--radius-pill)",
										padding: "2px 10px",
										fontSize: "0.78rem",
									}}>
										{row.score as number} pts
									</span>
								</div>
							);
						})}
					</div>
				</div>

				{/* ── Play again ── */}
				<Link to={"/p/" + (party.nextPartyId || "")} style={{ textDecoration: "none" }}>
					<button style={{
						width: "100%",
						padding: "var(--space-4)",
						borderRadius: "var(--radius-lg)",
						border: "none",
						background: "var(--accent)",
						color: "#fff",
						fontWeight: 700,
						fontSize: "1rem",
						fontFamily: "var(--font-ui)",
						cursor: "pointer",
						boxShadow: "0 2px 12px rgba(255,107,107,0.3)",
					}}>
						Play Again
					</button>
				</Link>

			</div>
		</div>
	);
}

export default PartyResults;
